module.exports = __webpack_public_path__ + "img/header.c0edf036.png";